import { Address } from 'models/contract'

export const getAddressFormatted = (emptyPlaceholder: string, address?: Address) => {
    return address
        ? `${address?.streetAddress ? `${address?.streetAddress}, ` : ''}${address?.postalCode ?? '-'} 
        ${address?.city ?? ''}`
        : emptyPlaceholder
}

export const formatDecimal = (value: number) => {
    return value.toLocaleString('en-US', { minimumFractionDigits: 2 })
}

export const toDecimalWithCurrency = (value: number) => {
    return `${value ? value.toLocaleString('en-US', { minimumFractionDigits: 2 }) : 0} kr`
}

export const formatVatPercentage = (vatPercentage: number) => {
    return vatPercentage ? vatPercentage + ' %' : '-'
}
